import { render, staticRenderFns } from "./expenseDetails.vue?vue&type=template&id=1571a6ac&scoped=true"
import script from "./expenseDetails.vue?vue&type=script&lang=js"
export * from "./expenseDetails.vue?vue&type=script&lang=js"
import style0 from "./expenseDetails.vue?vue&type=style&index=0&id=1571a6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571a6ac",
  null
  
)

export default component.exports